<div class="opening-times-label">{{ 'COMPANY_SEARCH.OPENING_TIMES' | translate }}</div>

@let openingTimes = this.openingTimes();

@if (openingTimesCanBeShown) {
    @for (entry of openingTimes; track entry) {
        <div>
            <div class="row">
                @if (!entry.lastDay) {
                    <div>{{ entry.firstDay | weekDayPipe | translate }} :</div>
                }
                @if (entry.lastDay) {
                    <div>
                        {{ entry.firstDay | weekDayPipe | translate }} - {{ entry.lastDay | weekDayPipe | translate }} :
                    </div>
                }
                <div class="intervals">
                    @for (interval of entry.timeIntervals; track interval) {
                        <div>{{ interval.from }} - {{ interval.to }} {{ 'CLOCK' | translate }}</div>
                    }
                </div>
            </div>
        </div>
    }
} @else {
    <div class="instructions">{{ 'COMPANY_SEARCH.OPENING_HOURS_INSTRUCTIONS' | translate }}</div>
}

<ng-template #instructions>
    <div class="instructions">{{ 'COMPANY_SEARCH.OPENING_HOURS_INSTRUCTIONS' | translate }}</div>
</ng-template>
